import { animateBackdrop } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export const SiteHeader = ({ animated, children, className, fadeIn, headerRef, sticky, variant, ...rest }) => {
    const fallbackRef = useRef(null);
    const ref = headerRef || fallbackRef;
    useEffect(() => {
        if (ref.current && animated) {
            const cleanup = animateBackdrop(ref.current);
            return cleanup;
        }
        return;
    }, [children, animated, ref]);
    return (React.createElement("header", { className: cx('tds-site-header', {
            [`tds-site-header--${variant}`]: variant,
            'tds--fade-in': fadeIn,
            'tds-site-header--sticky': sticky,
        }, className), id: "tds-site-header", ref: ref, ...rest },
        animated && React.createElement("div", { className: "tds-animate--backdrop-backdrop" }),
        children));
};
